import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { apiCall } from "./calendarUtils";
import { DateField } from "./DateField";

const TIMES = Array.from({ length: 28 }, (_, i) => `${String(8 + Math.floor(i / 2)).padStart(2, "0")}:${i % 2 ? "30" : "00"}`);

export function SlotPicker({ token, value, onChange, duration, trainingType, excludeId, prefix }) {
  const [check, setCheck] = useState(null);

  useEffect(() => {
    if (!value.date || !value.time) { setCheck(null); return; }
    const qs = new URLSearchParams({ date: value.date, time: value.time, duration, training_type: trainingType, exclude_id: excludeId });
    apiCall(token, `/booking-rules/admin/check?${qs}`).then(setCheck).catch(() => setCheck(null));
  }, [token, value.date, value.time, duration, trainingType, excludeId]);

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="text-[#A1A1AA] text-xs">Datum</Label>
          <DateField value={value.date} onChange={(v) => onChange({ ...value, date: v })} testId={`${prefix}-date`} />
        </div>
        <div>
          <Label className="text-[#A1A1AA] text-xs">Uhrzeit</Label>
          <select value={value.time} onChange={(e) => onChange({ ...value, time: e.target.value })} className="w-full h-10 px-2 bg-[#0A0A0A] border border-white/20 text-white rounded-md" data-testid={`${prefix}-time`}>
            <option value="">–</option>
            {TIMES.map((t) => <option key={t} value={t}>{t} Uhr</option>)}
          </select>
        </div>
      </div>
      {check && (
        <p className={`text-xs ${check.available ? "text-green-400" : "text-red-400"}`} data-testid={`${prefix}-check`}>
          {check.available ? "Zeitfenster ist frei und entspricht den Buchungsregeln." : check.reason}
        </p>
      )}
    </div>
  );
}
